export const FONT_STYLE_DATA = {
  default: {
    name: 'Default',
    font: {
      name: 'NA',
      url: 'NA',
    },
    styles: [],
    exclude_styles: ['handwriting', 'monospace'],
    min_font_weight: 100,
    max_font_weight: 900,
  },
  slogan: {
    name: 'Slogan',
    font: {
      name: 'NA',
      url: 'NA',
    },
    styles: ['sans-serif'],
    exclude_styles: [],
    min_font_weight: 300,
    max_font_weight: 500,
  },
  modern: {
    name: 'Modern',
    font: {
      name: 'Fira Sans bold',
      url:
        'https://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnSKzuQR37fF3Wlg.ttf',
    },
    exclude_styles: [],
    styles: ['sans-serif'],
    min_font_weight: 400,
    max_font_weight: 500,
  },
  handwritten: {
    name: 'Handwritten',
    font: {
      name: 'Pacifico Regular',
      url:
        'https://fonts.gstatic.com/s/pacifico/v17/FwZY7-Qmy14u9lezJ96A4sijpFu_.ttf',
    },
    exclude_styles: [],
    styles: ['handwriting'],
    min_font_weight: 100,
    max_font_weight: 900,
  },
  elegant: {
    name: 'Elegant',
    font: {
      name: 'Alex Brush Regular',
      url:
        'https://fonts.gstatic.com/s/alexbrush/v12/SZc83FzrJKuqFbwMKk6EtUL57DtOmCc.ttf',
    },
    styles: ['handwriting'],
    exclude_styles: [],
    min_font_weight: 100,
    max_font_weight: 400,
  },
  classy: {
    name: 'Classy',
    font: {
      name: 'DM Serif Display Regular',
      url:
        'https://fonts.gstatic.com/s/dmserifdisplay/v4/-nFnOHM81r4j6k0gjAW3mujVU2B2K_d709jy92k.ttf',
    },
    styles: ['serif'],
    exclude_styles: [],
    min_font_weight: 100,
    max_font_weight: 900,
  },
  vintage: {
    name: 'Vintage',
    font: {
      name: 'Limelight Regular',
      url:
        'https://fonts.gstatic.com/s/limelight/v11/XLYkIZL7aopJVbZJHDuYPeNGrnY2TA.ttf',
    },
    styles: ['serif'],
    exclude_styles: [],
    min_font_weight: 100,
    max_font_weight: 900,
  },
  bold: {
    name: 'Bold',
    font: {
      name: 'Lilita One Regular',
      url:
        'https://fonts.gstatic.com/s/lilitaone/v8/i7dPIFZ9Zz-WBtRtedDbUEZ2RFq7AwU.ttf',
    },
    styles: [],
    exclude_styles: ['handwriting'],
    min_font_weight: 700,
    max_font_weight: 900,
  },
  thin: {
    name: 'Thin',
    font: {
      name: 'Lilita One Regular',
      url:
        'https://fonts.gstatic.com/s/lilitaone/v8/i7dPIFZ9Zz-WBtRtedDbUEZ2RFq7AwU.ttf',
    },
    styles: [],
    exclude_styles: ['handwriting', 'display', 'monospace'],
    min_font_weight: 200,
    max_font_weight: 300,
  },
  quirky: {
    name: 'Quirky',
    font: {
      name: 'Faster One Regular',
      url:
        'https://fonts.gstatic.com/s/fasterone/v12/H4ciBXCHmdfClFb-vWhfyLuShq63czE.ttf',
    },
    styles: ['display'],
    exclude_styles: [],
    min_font_weight: 100,
    max_font_weight: 400,
  },
  bubbly: {
    name: 'Bubbly',
    font: {
      name: 'Modak Regular',
      url: 'https://fonts.gstatic.com/s/modak/v5/EJRYQgs1XtIEsnMH8BVZ76KU.ttf',
    },
    styles: ['display'],
    exclude_styles: [],
    min_font_weight: 400,
    max_font_weight: 400,
  },
  outline: {
    name: 'Outline',
    font: {
      name: 'Monoton Regular',
      url:
        'https://fonts.gstatic.com/s/monoton/v10/5h1aiZUrOngCibe4fkbBQ2S7FU8.ttf',
    },
    styles: [],
    exclude_styles: [],

    min_font_weight: 100,
    max_font_weight: 900,
  },
  handwriting: {
    name: 'Handwriting',
    font: {
      name: 'NA',
      url: 'NA',
    },
    styles: ['handwriting'],
    exclude_styles: [],

    min_font_weight: 100,
    max_font_weight: 900,
  },
  'sans-serif': {
    name: 'Sans Serif',
    font: {
      name: 'NA',
      url: 'NA',
    },
    exclude_styles: [],
    styles: ['sans-serif'],
    min_font_weight: 100,
    max_font_weight: 900,
  },
  serif: {
    name: 'Serif',
    font: {
      name: 'NA',
      url: 'NA',
    },
    exclude_styles: [],
    styles: ['serif'],
    min_font_weight: 100,
    max_font_weight: 900,
  },
  display: {
    name: 'Display',
    font: {
      name: 'NA',
      url: 'NA',
    },
    exclude_styles: [],
    styles: ['display'],
    min_font_weight: 100,
    max_font_weight: 900,
  },
  monospace: {
    name: 'Monospace',
    font: {
      name: 'NA',
      url: 'NA',
    },
    exclude_styles: [],
    styles: ['monospace'],
    min_font_weight: 100,
    max_font_weight: 900,
  },
}

export function getFilter(filterName) {
  const filter = FONT_STYLE_DATA[filterName]
  return !!filter ? filter : FONT_STYLE_DATA.default
}

export const familyPassesFilter = (family, filterName) => {
  const {
    exclude_styles,
    styles,
    min_font_weight,
    max_font_weight,
  } = getFilter(filterName)
  const valid_variants = family.variant_map.filter(
    variant =>
      variant.numeric >= min_font_weight && variant.numeric <= max_font_weight
  )
  if (valid_variants.length === 0) return false

  const {
    category: { name },
  } = family

  if (styles.length > 0) {
    return styles.includes(name)
  }
  if (exclude_styles.length > 0 && styles.length === 0) {
    return !exclude_styles.includes(name)
  }

  return true
}
